'use client';

import MemoBoard from '@/components/MemoBoard';

export default function Home() {
  return <MemoBoard />;
}
